<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Woodhouse Mystery</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li><li id="toc-li-3"><a href="#/text/ch003#chapter-1-a-reconciliation">Chapter 1: A Reconciliation</a></li><li id="toc-li-4"><a href="#/text/ch004#chapter-2-river-runners">Chapter 2: River Runners</a></li><li id="toc-li-5"><span href="#/text/ch005#chapter-3-a-brittle-covenant" title="Link target outside of Sample">Chapter 3: A Brittle Covenant</span></li><li id="toc-li-6"><span href="#/text/ch006#chapter-4-an-untidy-truth" title="Link target outside of Sample">Chapter 4: An Untidy Truth</span></li><li id="toc-li-7"><span href="#/text/ch007#chapter-5-a-confession" title="Link target outside of Sample">Chapter 5: A Confession</span></li><li id="toc-li-8"><span href="#/text/ch008#chapter-6-a-hummingbird-bouquet" title="Link target outside of Sample">Chapter 6: A Hummingbird Bouquet</span></li><li id="toc-li-9"><span href="#/text/ch009#chapter-7-the-oracle" title="Link target outside of Sample">Chapter 7: The Oracle</span></li><li id="toc-li-10"><span href="#/text/ch010#chapter-8-unintended-consequences" title="Link target outside of Sample">Chapter 8: Unintended Consequences</span></li><li id="toc-li-11"><span href="#/text/ch011#chapter-9-release-and-revelation" title="Link target outside of Sample">Chapter 9: Release and Revelation</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?7b0c4f68